module.exports = __webpack_public_path__ + "img/chevron-circle-right-16px-dark.73f04dc.svg";